import {
  type DesignTemplate,
  designTemplateApi,
  type DesignTemplateListParams,
} from '@mathflat/domain/DesignTemplate'

import { CustomPrintDesignTemplate } from '@/dto/DesignTemplate/CustomPrintDesignTemplate'
import { WorkbookDesignTemplate } from '@/dto/DesignTemplate/WorkbookCoverDesignTemplate'

class DesignTemplateController {
  async getDesignTemplateSummaries(color: DesignTemplateListParams['color']) {
    return designTemplateApi.getDesignTemplates({ color })
  }

  async getDesignTemplateById(
    id: DesignTemplate['id'],
    {
      withoutSalesPrice = false,
      designTemplateType = 'WorkbookDesignTemplate',
    }: {
      // 맞춤 인쇄물은 판매가 칸을 쓰지 않아 칸째 빼고 받는다
      withoutSalesPrice?: boolean
      designTemplateType?: 'WorkbookDesignTemplate' | 'CustomPrintDesignTemplate'
    } = {},
  ) {
    const designTemplate = await designTemplateApi.getDesignTemplate(id)
    const { salesPrice: _, ...coverDataWithoutSalesPrice } = designTemplate.coverData
    const newDesignTemplate: DesignTemplate = withoutSalesPrice
      ? { ...designTemplate, coverData: coverDataWithoutSalesPrice }
      : designTemplate

    if (designTemplateType === 'CustomPrintDesignTemplate') {
      return new CustomPrintDesignTemplate(newDesignTemplate)
    }

    return new WorkbookDesignTemplate(newDesignTemplate)
  }

  async getFavoriteDesignTemplate() {
    return designTemplateApi.getFavoriteDesignTemplates()
  }

  async postFavoriteDesignTemplate(id: DesignTemplate['id']) {
    await designTemplateApi.favoriteDesignTemplate(id)
  }

  async deleteFavoriteDesignTemplate(id: DesignTemplate['id']) {
    await designTemplateApi.unfavoriteDesignTemplate(id)
  }
}

export const designTemplateController = new DesignTemplateController()
